module.exports = __webpack_public_path__ + "static/media/Logo.52e38ae6.svg";